import { tableViewNames } from "../../../../agent-production/constants/agentProductionConstants";
import { dividerClassNames } from "./colSettings";

const getCellSize = (cell) => (cell.offsetLeft + cell.offsetWidth);

export const handleColumnDividerObserver = ({ tableId, headerGroupColIds }) => {
    const allDividerElements = document.querySelectorAll(`#${tableId} .left-divider-col`);
    allDividerElements?.forEach(element => element.classList.remove(dividerClassNames.leftDividerCol));

    const groupCells = Array.from(document.querySelectorAll(`#${tableId} .ag-header-group-cell`));
    const headerCells = Array.from(document.querySelectorAll(`#${tableId} .ag-header-cell`));
    const agFloatingFilterCells = Array.from(document.querySelectorAll(`#${tableId} .ag-floating-filter`));

    headerGroupColIds.forEach(groupId => {
        const groupCell = groupCells.find(cell => cell.getAttribute('col-id') === groupId);
        if (!groupCell) return;

        groupCell.classList.add(dividerClassNames.leftDividerCol);
        const resizeElement = groupCell.querySelector(`#${tableId} .ag-header-cell-resize`);
        if (resizeElement) resizeElement.classList.add(dividerClassNames.transparentResizeIcon);

        const groupRight = getCellSize(groupCell);

        const groupHeaderCells = headerCells.filter(cell => {
            return Math.abs(getCellSize(cell) - groupRight) <= 20;
        });
        if (groupHeaderCells.length === 0) return;
        let lastHeaderCell = groupHeaderCells[0];
        let maxRight = getCellSize(lastHeaderCell);
        groupHeaderCells.forEach(cell => {
            const right = getCellSize(cell);
            if (right > maxRight) {
                lastHeaderCell = cell;
                maxRight = right;
            }
        });

        const agFloatingCells = agFloatingFilterCells.filter(cell => {
            return Math.abs(getCellSize(cell) - groupRight) <= 20;
        });
        agFloatingCells?.forEach(cell => cell.classList.add(dividerClassNames.leftDividerCol));

        if (lastHeaderCell) {
            lastHeaderCell.classList.add(dividerClassNames.leftDividerCol);
            const colId = lastHeaderCell.getAttribute('col-id');
            const rowCells = document.querySelectorAll(`#${tableId} .ag-cell[col-id='${colId}']`);
            rowCells?.forEach(cell => cell.classList.add(dividerClassNames.leftDividerCol));
            groupCell.classList.add(dividerClassNames.leftDividerCol);
            const resizeElement = lastHeaderCell.querySelector(`#${tableId} .ag-header-cell-resize`);
            if (resizeElement) resizeElement.classList.add(dividerClassNames.transparentResizeIcon);
        }
    });
};

const headerGroupColIdsByTableId = {
    [tableViewNames.agentMovement]: ['0_0', '1_0', '2_0'],
};

export const getColumnDividerObserver = (tableId) => {
    if (!headerGroupColIdsByTableId[tableId]) {
        return null;
    }

    return new MutationObserver(() => {
        setTimeout(() => {
            const tableNode = document.querySelector(`#${tableId}`);
            if (tableNode) handleColumnDividerObserver({
                tableId,
                headerGroupColIds: headerGroupColIdsByTableId[tableId]
            });
        }, 200);
    });
};
